import { FormattedMessage } from 'react-intl';

const NO_LIMIT_THRESHOLD = 100000;

export interface BudgetQuantityProps {
    quantity: number;
}

export const BudgetQuantity = ({ quantity }: BudgetQuantityProps) => {
    if (quantity > NO_LIMIT_THRESHOLD) {
        return (
            <FormattedMessage
                id='wizard.budget.no-limit'
                defaultMessage='No limit'
            />
        );
    }

    return quantity;
};
